import ViewProfile from "../../images/menu-icons/user.png";
import MySettings from "../../images/menu-icons/settings.png";
import CreatorSettings from "../../images/menu-icons/creator-settings.png";
import Performance from "../../images/menu-icons/performance.png";
import Followers from "../../images/menu-icons/followers.png";
import Following from "../../images/menu-icons/following.png";
import MyReferrals from "../../images/menu-icons/my-referrals.png";
import AddAccount from "../../images/menu-icons/add-account.png";
import AddCard from "../../images/menu-icons/add-card.png";
import DarkMode from "../../images/menu-icons/dark-mode.png";
import LightMode from "../../images/menu-icons/light-icon.png";
import HelpFaq from "../../images/menu-icons/help-faqs.png";
import Logout from "../../images/menu-icons/logout.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
    List,
    ListItem,
    Divider,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { ROLES } from "../../utils/constants";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { connect, useDispatch } from "react-redux";

import "./user-menu.scss";
import "./style.darkmode.scss";
import { setDarkmode } from "../../../redux/actions";

const UserMenu = ({ darkmode, user, setOpen = () => {} }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const goTo = (path) => {
        history.push(path);
        setOpen(false);
    };

    const handleLogout = async (e) => {
        e.preventDefault();
        await axios.post("/api/logout").then((response) => {
            localStorage.clear();
            window.location = "/login";
        });
    };

    const handleDarkMode = () => {
        if (!darkmode) {
            localStorage.setItem("darkmode", "true");
            document.body.classList.remove("lightmode");
            document.body.classList.add("darkmode");
        } else {
            localStorage.setItem("darkmode", "false");
            document.body.classList.remove("darkmode");
            document.body.classList.add("lightmode");
        }

        dispatch(setDarkmode(!darkmode));
    };

    return (
        <List className="user-menu">
            {user.role === ROLES.ADMIN ? (
                <ListItem onClick={() => goTo("/administration/dashboard")}>
                    <ListItemIcon>
                        <LazyLoadImage src={MySettings} />
                    </ListItemIcon>
                    <ListItemText>Administration</ListItemText>
                </ListItem>
            ) : (
                ""
            )}

            {user.role === ROLES.ADMIN ? <Divider /> : ""}

            <ListItem onClick={() => goTo(`/${user.login}`)}>
                <ListItemIcon>
                    <LazyLoadImage src={ViewProfile} />
                </ListItemIcon>
                <ListItemText>View Profile</ListItemText>
            </ListItem>

            <ListItem onClick={() => goTo("/edit-profile")}>
                <ListItemIcon>
                    <LazyLoadImage src={MySettings} />
                </ListItemIcon>
                <ListItemText>My Settings</ListItemText>
            </ListItem>

            <ListItem onClick={() => goTo("/become-creator")}>
                <ListItemIcon>
                    <LazyLoadImage src={CreatorSettings} />
                </ListItemIcon>
                <ListItemText>
                    {user.role === ROLES.PU
                        ? "Creator Settings"
                        : "Become Creator (Earn $)"}
                </ListItemText>
            </ListItem>

            {[ROLES.PU, ROLES.ADMIN].includes(user.role) && (
                <ListItem onClick={() => goTo("/welcome-messages")}>
                    <ListItemIcon>
                        <LazyLoadImage src={AddAccount} />
                    </ListItemIcon>
                    <ListItemText>Welcome Messages</ListItemText>
                </ListItem>
            )}

            {([ROLES.ADMIN, ROLES.PU].includes(user.role) ||
                user.referral1_count > 0 ||
                user.referral2_count > 0) && (
                <ListItem onClick={() => goTo("/performance")}>
                    <ListItemIcon>
                        <LazyLoadImage src={Performance} />
                    </ListItemIcon>
                    <ListItemText>Performance</ListItemText>
                </ListItem>
            )}

            {([ROLES.ADMIN, ROLES.PU].includes(user.role) ||
                user.referral1_count > 0 ||
                user.referral2_count > 0) && (
                <ListItem onClick={() => goTo("/user-lists")}>
                    <ListItemIcon>
                        <i className="fa-light fa-users"></i>
                    </ListItemIcon>
                    <ListItemText>User Lists</ListItemText>
                </ListItem>
            )}

            {user.role !== 0 && <Divider />}

            {user.role !== ROLES.SU && (
                <ListItem onClick={() => goTo("/followers")}>
                    <ListItemIcon>
                        <LazyLoadImage src={Followers} />
                    </ListItemIcon>
                    <ListItemText>Followers</ListItemText>
                </ListItem>
            )}

            <ListItem onClick={() => goTo("/following")}>
                <ListItemIcon>
                    <LazyLoadImage src={Following} />
                </ListItemIcon>
                <ListItemText>Subscriptions</ListItemText>
            </ListItem>

            <ListItem onClick={() => goTo("/my-referrals")}>
                <ListItemIcon>
                    <LazyLoadImage src={MyReferrals} />
                </ListItemIcon>
                <ListItemText>My Referrals</ListItemText>
            </ListItem>

            <Divider />

            <ListItem onClick={() => goTo("/add-account")}>
                <ListItemIcon>
                    <LazyLoadImage src={AddAccount} />
                </ListItemIcon>
                <ListItemText>Add account (To receive $$)</ListItemText>
            </ListItem>

            <ListItem onClick={() => goTo("/payment-details")}>
                <ListItemIcon>
                    <LazyLoadImage src={AddCard} />
                </ListItemIcon>
                <ListItemText>Add Card (To subscribe)</ListItemText>
            </ListItem>

            <Divider />

            {darkmode ? (
                <ListItem onClick={handleDarkMode}>
                    <ListItemIcon>
                        <i className="fa-light fa-sun-bright"></i>
                    </ListItemIcon>
                    <ListItemText>Light Mode</ListItemText>
                </ListItem>
            ) : (
                <ListItem onClick={handleDarkMode}>
                    <ListItemIcon>
                        <i className="fa-duotone fa-moon"></i>
                    </ListItemIcon>
                    <ListItemText>Dark Mode</ListItemText>
                </ListItem>
            )}

            <ListItem
                onClick={() =>
                    (window.location.href = "https://priva.uvdesk.com/en/")
                }
            >
                <ListItemIcon>
                    <LazyLoadImage src={HelpFaq} />
                </ListItemIcon>
                <ListItemText>Help & FAQs</ListItemText>
            </ListItem>

            <ListItem onClick={handleLogout}>
                <ListItemIcon>
                    <LazyLoadImage src={Logout} />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
            </ListItem>
        </List>
    );
};

const mapStateToProps = (state) => ({
    user: state.user.user,
    darkmode: state.privaGlobal.darkmode,
});

export default connect(mapStateToProps)(UserMenu);
